import { render, staticRenderFns } from "./FormAssignPackagesHighlights.vue?vue&type=template&id=2dc2ea7b"
import script from "./FormAssignPackagesHighlights.vue?vue&type=script&lang=js"
export * from "./FormAssignPackagesHighlights.vue?vue&type=script&lang=js"
import style0 from "./FormAssignPackagesHighlights.vue?vue&type=style&index=0&id=2dc2ea7b&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports